// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mkmcnfedsnijmlymlbsl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1rbWNuZmVkc25pam1seW1sYnNsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNTI2NTMsImV4cCI6MjA2MzkyODY1M30.faWJ4qGQ6RNsMVuPhB6AJuVMZRBK-gD-KnoBIiUYIDs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);